// extracted by mini-css-extract-plugin
module.exports = {"spinner":"AuthChecker_spinner__1WM8z"};